import { queryClient } from "@/lib/queryClient";
import { createAnalytics } from "./contract";
import {
  analyticsPreferenceOptions,
  relayAnalyticsEvent,
  type AnalyticsPreference,
} from "./api";
import { analyticsStoppedForActor } from "./preference";
import { analyticsRolloutEnabled } from "./config";
export const analyticsEnabled = analyticsRolloutEnabled(
  typeof window === "undefined" ? undefined : window.__TRIPBEARS_CONFIG__,
  import.meta.env.VITE_RUNTIME_CONFIG === "true",
  import.meta.env.VITE_ANALYTICS_ENABLED,
);
export const analytics = createAnalytics(
  "web",
  async (event, signal, actorKey) => {
    const preference = queryClient.getQueryData<AnalyticsPreference>(
      analyticsPreferenceOptions(actorKey).queryKey,
    );
    if (
      queryClient.getQueryData<{ user: { id: string } }>(["session"])?.user
        .id !== actorKey ||
      browserPrivacyOptOut() ||
      analyticsStoppedForActor(actorKey) ||
      !preference?.enabled ||
      !preference.consented
    )
      return;
    await relayAnalyticsEvent(event, signal);
  },
  () => crypto.randomUUID(),
);
export function browserPrivacyOptOut() {
  return (
    typeof navigator !== "undefined" &&
    (navigator.doNotTrack === "1" ||
      (navigator as Navigator & { globalPrivacyControl?: boolean })
        .globalPrivacyControl === true)
  );
}
